import React, { Component } from "react";
import MaestroSelect from "@components/reports/MaestroSelect";
// import './NewReport.scss';
import { authenticatedApi } from "api";
import {
    format,
    endOfDay,
    startOfMonth,
    endOfMonth,
    isSameDay,
    subDays,
    startOfYear,
    endOfYear,
    startOfQuarter,
    endOfQuarter,
    getYear,
    parseISO,
    isAfter,
} from 'date-fns';
import MaestroDateRangePicker from "@components/reports/MaestroDateRangePicker";
import ReportResults from "@components/reports/ReportResults";
import MaestroRelationship from "@components/reports/MaestroRelationship";
import MaestroMultiSearch, {operators as multiSearchOperators, objectToSelectOptions} from "@components/reports/MaestroMultiSearch";
import { Accordion, AccordionDetails, AccordionGroup, AccordionSummary, Box, Button, Card, CardActions, CardContent, CardOverflow, Chip, Divider, FormControl, FormHelperText, FormLabel, Stack, Switch, ToggleButtonGroup, Typography } from "@mui/joy";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
// import SavePdf, { ShowPdf } from "@components/reports/SavePdf";
import MaestroSearchSelect from "@components/reports/MaestroSearchSelect";
// import DatePicker from 'react-date-picker'
import { useLocation } from "react-router-dom";
import { DatePicker } from "@components/forms/DatePicker";
import { useAuth } from "@providers/AuthProvider";
import MaestroLoader from "@components/MaestroLoader";
import { formatIso } from "@utils/dates";
import { useDocumentTitle } from "@uidotdev/usehooks";
import { events } from "@utils/analytics";

const formatDateForRequest = (date) => {
    return format(date, 'yyyy-MM-dd HH:mm:ss');
};

const dateRangePresets = [
    {
        label: 'All Time',
        startDate: new Date(1001, 0, 1),
        endDate: endOfDay(new Date()),
    },
    {
        label: 'This Year',
        startDate: startOfYear(new Date()),
        endDate: endOfYear(new Date()),
    },
    {
        label: 'This Quarter',
        startDate: startOfQuarter(new Date()),
        endDate: endOfQuarter(new Date()),
    },
    {
        label: 'This Month',
        startDate: startOfMonth(new Date()),
        endDate: endOfMonth(new Date()),
    },
];

class UnhookedNewReport extends Component {

    state = {
        loading: false,
        result: null,
        reportInfo: {
            communityName: '',
            name: '',
            author: '',
            description: '',
        },

        selectedCommunities: [],
        selectedObjects: [],
        includedFilteredObjects: [],
        selectedDisplayFields: [],
        selectedAggregates: [],
        aggregateDateRange: {
            startDate: startOfYear(new Date()),
            endDate: endOfYear(new Date()),
            key: 'selection',
        },
        aggregateStatsOnly: false,

        availableCommunities: [],
        allFields: [],
        allAggregates: [
            // Businesses
            { label: 'Businesses by Type', value: 'businesses_by_type', affected_by_filters: true },
            { label: 'Businesses Relocated', value: 'businesses_relocated', affected_by_filters: true },
            { label: 'Closed Businesses', value: 'closed_businesses', affected_by_filters: true },
            { label: 'Employee Changes', value: 'employee_changes' , affected_by_filters: true},
            { label: 'New Businesses', value: 'new_businesses', affected_by_filters: true },
            { label: 'Not For Profit Businesses', value: 'not_for_profit', affected_by_filters: true },
            { label: 'Active Businesses', value: 'total_businesses', affected_by_filters: true },
            { label: 'Employees in Active Businesses', value: 'total_employees', affected_by_filters: true },

            // Contacts

            // Donations

            // Other
            { label: 'Grants Received', value: 'grants_received' },
            { label: 'Event Attendance', value: 'event_attendance' },
            { label: 'Events Held', value: 'events_held' },
            { label: 'Parking', value: 'parking', affected_by_filters: true },
            { label: 'Number of Parks', value: 'parks' },
            { label: 'Public Improvements', value: 'public_improvements' },
            { label: 'Public Investments', value: 'public_investments' },
            { label: 'Return on Investment (ROI)', value: 'roi', affected_by_filters: true },
            { label: 'Trainings Held', value: 'trainings_held' },

            // Properties
            { label: 'Assessed Market Value', value: 'assessed_market_value', affected_by_filters: true },
            { label: 'Property Improvements', value: 'improved_properties', affected_by_filters: true },
            { label: 'Properties Lost', value: 'lost_properties', affected_by_filters: true },
            { label: 'New Properties', value: 'new_properties', affected_by_filters: true },
            { label: 'New Residential Units', value: 'new_residential_units', affected_by_filters: true },
            { label: 'Occupancy Rate', value: 'occupancy_rate', affected_by_filters: true },
            { label: 'Properties by Type', value: 'properties_by_type', affected_by_filters: true },
            { label: 'Rent Per Square Foot', value: 'rent_per_square_foot', affected_by_filters: true },
            { label: 'Property Sales', value: 'sold_properties', affected_by_filters: true },
            { label: 'Total Properties', value: 'total_properties', affected_by_filters: true },
            { label: 'Total Residential Units', value: 'total_residential_units', affected_by_filters: true },
            { label: 'Total Commercial Units', value: 'total_commercial_units', affected_by_filters: true },
            // { label: 'Total Residents', value: 'total_residents', affected_by_filters: true },

            // Work Plans
            { label: 'Transformational Strategy Goals Met', value: 'transformational_strategies' },

            // Vounteer Hours
            { label: 'Staff/Volunteer Hours', value: 'staff_volunteer_hours' },
        ],

        defaultFields: [
            /*
            { select_by_default: true, label: "Created At", value: "created_at", type: 'date' },
            { select_by_default: true, label: "Updated At", value: "updated_at", type: 'date' },
            { select_by_default: true, label: "Involvement", value: "involvement", type: 'involvement' }, // maybe
            { select_by_default: true, label: "Related To Contact", value: "related_to_contact", type: 'select', multi_community: false }, // maybe
            { select_by_default: true, label: "Related To Business", value: "related_to_business", type: 'select', multi_community: false }, // maybe
            { select_by_default: true, label: "Related To Property", value: "related_to_property", type: 'select', multi_community: false }, // maybe
            */
        ],

        filterableObjects: [
            {
                name: "Contacts",
                slug: 'contact',
                value: 'contacts', // for api
            },
            {
                name: "Businesses",
                slug: 'business',
                value: 'businesses', // for api
            },
            {
                name: "Properties",
                slug: 'property',
                value: 'properties', // for api
            },
            {
                name: "Work Plans",
                slug: 'work-plan',
                value: 'work-plans', // for api
            }
        ],

        objects: [
            // todo: add "all"
            {
                name: "Contacts",
                slug: 'contact',
                value: 'contacts', // for api
                searchExpanded: false,
                displayExpanded: false,
                availableFields: [
                    // { select_by_default: true, label: 'Photo', value: 'profile_image', type: 'has' }, // this doesn't work because it's an attribute
                    { select_by_default: true, label: 'Title', value: 'title' },
                    { select_by_default: true, label: 'First Name', value: 'first_name' },
                    { select_by_default: true, label: 'Last Name', value: 'last_name' },
                    { select_by_default: true, label: 'Company Name', value: 'company_name' },
                    { select_by_default: true, label: 'Do Not Contact', value: 'do_not_contact', type: 'boolean' },
                    { select_by_default: true, label: 'Email', value: 'email' },
                    { select_by_default: true, label: 'Alternate Email', value: 'alternate_email' },
                    // { select_by_default: true, label: 'Birthday', value: 'birthday' },
                    // { select_by_default: true, label: 'Deceased', value: 'deceased' },
                    { select_by_default: true, label: 'Has Spouse', value: 'spouse', type: 'boolean' },
                    // { select_by_default: true, label: 'Anniversary', value: 'anniversary' },
                    { select_by_default: true, label: 'Address', value: 'address' },
                    { select_by_default: true, label: 'Address (cont.)', value: 'address_2' },
                    { select_by_default: true, label: 'Country', value: 'country' },
                    { select_by_default: true, label: 'Zip / Postal Code', value: 'zip_postal' },
                    { select_by_default: true, label: 'City', value: 'city' },
                    { select_by_default: true, label: 'State / Province', value: 'state_province' },
                    // { select_by_default: true, label: 'Latitude', value: 'latitude' }, // contact doesnt have this
                    // { select_by_default: true, label: 'Longitude', value: 'longitude' }, // contact doesnt have this
                    { select_by_default: true, label: 'Phone (Work)', value: 'work_phone' },
                    { select_by_default: true, label: 'Phone (Cell)', value: 'cell_phone' },
                    { select_by_default: true, label: 'Phone (Home)', value: 'home_phone' },
                    { select_by_default: true, label: 'Preferred Contact Method', value: 'preferred_contact_method', type: 'select', providedOptions: [{value: 'email', label: 'Email'}, {value: 'home', label: 'Home Phone'}, {value: 'cell', label: 'Cell Phone'}, {value: 'work', label: 'Work Phone'}] },
                    { select_by_default: true, label: 'Is Staff?', value: 'is_staff', type: 'boolean' },
                    { select_by_default: true, label: 'Notes', value: 'notes' },
                    { select_by_default: true, label: 'Veteran', value: 'is_veteran', type: 'boolean' },
                    { select_by_default: true, label: 'Minority', value: 'is_minority', type: 'boolean' },
                    { select_by_default: true, label: 'Woman', value: 'is_female', type: 'boolean' },
                    { select_by_default: true, label: 'LGBT', value: 'is_lgbt', type: 'boolean' },

                    { select_by_default: true, label: 'Volunteer Hours', value: 'volunteer_hours', type: 'number_between' },
                    { select_by_default: true, label: 'Related to Work Plan', value: 'related_to_workplan', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'Number of Tasks', value: 'tasks', type: 'number_between' },
                    { select_by_default: true, label: 'Last Contacted', value: 'contacted', type: 'date' },
                    { select_by_default: true, label: 'Birthday', value: 'birthday', type: 'relative_date' },
                    { select_by_default: true, label: 'Deceased Date', value: 'deceased', type: 'date' },
                    { select_by_default: true, label: 'Is Deceased?', value: 'deceased_status', type: 'boolean' },
                    { select_by_default: true, label: 'Anniversary Date', value: 'anniversary', type: 'relative_date' },
                    { select_by_default: true, label: "Created Date", value: "created_at", type: 'date' },
                    { select_by_default: true, label: "Updated Date", value: "updated_at", type: 'date' },
                    { select_by_default: true, label: "Involvement", value: "involvement", type: 'involvement' },

                    { select_by_default: true, label: "Related To Business", value: "related_to_business", type: 'select', multi_community: false },
                    { select_by_default: true, label: "Related To Property", value: "related_to_property", type: 'select', multi_community: false },
                    { select_by_default: true, label: "Related To Volunteer Opportunity", value: "related_to_opportunity", type: 'select', multi_community: false },

                    { select_by_default: true, label: '# of Properties', value: 'owned_properties', type: 'number' },

                    { label: 'All', value: 'all', type: 'all' },
                ],
                availableAggregates: [
                    //
                ],
            },
            {
                name: "Businesses",
                slug: 'business',
                value: 'businesses', // for api
                searchExpanded: false,
                displayExpanded: false,
                availableFields: [
                    { select_by_default: true, label: 'Name', value: 'name' },
                    { select_by_default: true, label: 'DBA Name', value: 'dba_name' },
                    { select_by_default: true, label: 'Business Type', value: 'business_type', type: 'select' },
                    // { select_by_default: true, label: 'Primary Contact', value: 'primary_contact' }, // this is handled by related to contact
                    { select_by_default: true, label: 'Do Not Contact', value: 'do_not_contact', type: 'boolean' },
                    { select_by_default: true, label: 'Phone', value: 'phone' },
                    { select_by_default: true, label: 'Fax', value: 'fax' },
                    { select_by_default: true, label: 'Email', value: 'email' },
                    { select_by_default: true, label: 'Mailing Country', value: 'country_mail' },
                    { select_by_default: true, label: 'Mailing Zip/Postal Code', value: 'zip_postal_mail' },
                    { select_by_default: true, label: 'Mailing Address', value: 'address_mail' },
                    { select_by_default: true, label: 'Mailing Address (cont.)', value: 'address_2_mail' },
                    { select_by_default: true, label: 'Mailing City', value: 'city_mail' },
                    { select_by_default: true, label: 'Mailing State/Province', value: 'state_province_mail' },
                    { select_by_default: true, label: 'Membership Level', value: 'membership_level', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'Tax ID', value: 'tax_id' },
                    { select_by_default: true, label: 'Website', value: 'url' },
                    { select_by_default: true, label: 'Facebook', value: 'facebook_url' },
                    { select_by_default: true, label: 'Twitter', value: 'twitter_url' },
                    { select_by_default: true, label: 'Google Plus', value: 'google_plus_url' },
                    { select_by_default: true, label: 'Instagram', value: 'instagram_url' },
                    { select_by_default: true, label: 'LinkedIn', value: 'linkedin_url' },
                    { select_by_default: true, label: 'Youtube', value: 'youtube_url' },
                    { select_by_default: true, label: 'Yelp', value: 'yelp_url' },
                    { select_by_default: true, label: 'Description', value: 'description' },
                    { select_by_default: true, label: 'Not For Profit', value: 'not_for_profit', type: 'boolean' },
                    { select_by_default: true, label: 'In District', value: 'not_in_district', type: 'boolean' },
                    { select_by_default: true, label: 'Is Moved Out', value: 'is_moved_out', type: 'boolean' },
                    { select_by_default: true, label: 'Is Closed', value: 'is_closed', type: 'boolean' },
                    { select_by_default: true, label: 'Notes', value: 'notes' },
                    { select_by_default: true, label: 'Veteran-owned', value: 'is_veteran', type: 'boolean' },
                    { select_by_default: true, label: 'Minority-owned', value: 'is_minority', type: 'boolean' },
                    { select_by_default: true, label: 'Woman-owned', value: 'is_female', type: 'boolean' },
                    { select_by_default: true, label: 'LGBT-owned', value: 'is_lgbt', type: 'boolean' },

                    { select_by_default: true, label: 'Number of Employees', value: 'employees', type: 'number_between' },
                    { select_by_default: true, label: 'Date Opened', value: 'date_opened', type: 'date' },
                    { select_by_default: true, label: 'Date Closed', value: 'date_closed', type: 'date' },
                    { select_by_default: true, label: 'Date Relocated In', value: 'date_moved_in', type: 'date' },
                    { select_by_default: true, label: 'Date Relocated Out', value: 'date_moved_out', type: 'date' },
                    { select_by_default: true, label: 'Last Contacted', value: 'contacted', type: 'date' },
                    // { select_by_default: true, label: 'Social Media', value: 'social', type: 'has' },

                    // { select_by_default: true, label: 'Hours', value: 'hours' },
                    // { select_by_default: true, label: 'Properties', value: 'business_locations' },

                    { select_by_default: true, label: "Created Date", value: "created_at", type: 'date' },
                    { select_by_default: true, label: "Updated Date", value: "updated_at", type: 'date' },
                    { select_by_default: true, label: "Involvement", value: "involvement", type: 'involvement' },
                    { select_by_default: true, label: "Related To Contact", value: "related_to_contact", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Business", value: "related_to_business", type: 'select', multi_community: false },
                    { select_by_default: true, label: "Related To Property", value: "related_to_property", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Work Plan", value: "related_to_workplan", type: 'select', multi_community: false },

                    { select_by_default: true, label: '# of Properties', value: 'owned_properties', type: 'number' },

                    { label: 'All', value: 'all', type: 'all' },
                ],
                availableAggregates: [
                    //
                ],
            },
            {
                name: "Properties",
                slug: 'property',
                value: 'properties', // for api
                searchExpanded: false,
                displayExpanded: false,
                availableFields: [
                    // { select_by_default: true, label: 'Owner', value: 'owner' },
                    { select_by_default: true, label: 'Address', value: 'address' },
                    { select_by_default: true, label: 'Address (cont.)', value: 'address_2' },
                    { select_by_default: true, label: 'Country', value: 'country' },
                    { select_by_default: true, label: 'Zip/Postal Code', value: 'zip_postal' },
                    { select_by_default: true, label: 'City', value: 'city' },
                    { select_by_default: true, label: 'State/Province', value: 'state_province' },
                    { select_by_default: true, label: 'Latitude', value: 'latitude' },
                    { select_by_default: true, label: 'Longitude', value: 'longitude' },
                    { select_by_default: true, label: 'Parcel Number', value: 'parcel_number' },
                    { select_by_default: true, label: 'Land Use', value: 'land_use', type: 'select' },
                    { select_by_default: true, label: 'Square Footage', value: 'square_footage', type: 'number' },
                    { select_by_default: true, label: 'Square Footage Is Empty', value: 'square_footage_empty', type: 'boolean' },
                    { select_by_default: true, label: 'Number of Floors', value: 'floors', type: 'number' },
                    { select_by_default: true, label: 'Number of Residential Units', value: 'residential_units', type: 'number' },
                    { select_by_default: true, label: 'Residential Only', value: 'residential_only', type: 'boolean' },
                    { select_by_default: true, label: 'Number of Commercial Units', value: 'commercial_units', type: 'number' },
                    { select_by_default: true, label: 'In TIF', value: 'tif', type: 'select', multi_community: false },
                    // { select_by_default: true, label: 'In a TIF', value: 'tif_any', type: 'none', multi_community: 'only' },
                    { select_by_default: true, label: 'In SSA/BID', value: 'ssa', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'In Zone', value: 'zone', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'In Registry', value: 'registry', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'For Sale', value: 'for_sale', type: 'boolean' },
                    { select_by_default: true, label: 'For Lease', value: 'for_lease', type: 'boolean' },
                    { select_by_default: true, label: 'Enterprise Zone', value: 'enterprise', type: 'boolean' },
                    { select_by_default: true, label: 'Asking Price', value: 'asking_price', type: 'number' },
                    { select_by_default: true, label: 'Assessed Market Value', value: 'assessed_market_value', type: 'number' },
                    { select_by_default: true, label: 'Private Parking', value: 'private_parking', type: 'number' },
                    { select_by_default: true, label: 'Architect', value: 'architect' },
                    { select_by_default: true, label: 'Date Built', value: 'date_built', type: 'date' },
                    { select_by_default: true, label: 'Date Lost', value: 'date_lost', type: 'date' },
                    { select_by_default: true, label: 'Lost Reason', value: 'lost_reason' },
                    { select_by_default: true, label: 'Notes', value: 'notes' },
                    { select_by_default: true, label: 'Veteran-owned', value: 'is_veteran', type: 'boolean' },
                    { select_by_default: true, label: 'Minority-owned', value: 'is_minority', type: 'boolean' },
                    { select_by_default: true, label: 'Woman-owned', value: 'is_female', type: 'boolean' },
                    { select_by_default: true, label: 'LGBT-owned', value: 'is_lgbt', type: 'boolean' },
                    { select_by_default: true, label: 'Number of Units', value: 'units', type: 'number' },
                    { select_by_default: true, label: 'Number of Residents', value: 'residents', type: 'number_between' },
                    { select_by_default: true, label: 'Sold Date', value: 'date_sold', type: 'date' },
                    { select_by_default: true, label: 'Sold Price', value: 'sold_price', type: 'number' },
                    { select_by_default: true, label: 'Improvement Date', value: 'improvement_date', type: 'date' },
                    { select_by_default: true, label: 'Improvement Cost', value: 'improvement_cost', type: 'number' },
                    { select_by_default: true, label: 'Vacant Units', value: 'vacant_units', type: 'number' },
                    { select_by_default: true, label: 'Unit Square Footage', value: 'unit_square_footage', type: 'number' },
                    { select_by_default: true, label: 'Unit Rent', value: 'unit_rent', type: 'number' },
                    { select_by_default: true, label: 'Owned By Contact', value: 'contact_owner', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'Owned By Business', value: 'business_owner', type: 'select', multi_community: false },
                                        { select_by_default: true, label: 'Former Owner (Contact)', value: 'former_contact_owner', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'Former Owner (Business)', value: 'former_business_owner', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'Vacant', value: 'vacant', type: 'boolean' },

                    { select_by_default: true, label: "Created Date", value: "created_at", type: 'date' },
                    { select_by_default: true, label: "Updated Date", value: "updated_at", type: 'date' },
                    { select_by_default: true, label: "Involvement", value: "involvement", type: 'involvement' },
                    { select_by_default: true, label: "Related To Contact", value: "related_to_contact", type: 'select', multi_community: false },
                    { select_by_default: true, label: "Related To Business", value: "related_to_business", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Property", value: "related_to_property", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Work Plan", value: "related_to_workplan", type: 'select', multi_community: false },

                    { label: 'All', value: 'all', type: 'all' },
                ],
                availableAggregates: [
                    //
                ],
            },
            {
                name: "Work Plans",
                slug: 'work-plan',
                value: 'work-plans', // for api
                searchExpanded: false,
                displayExpanded: false,
                availableFields: [
                    { select_by_default: true, label: 'Name', value: 'name'},
                    { select_by_default: true, label: 'Work Plan Date', value: 'workplan_date', type: 'date' },
                    { select_by_default: true, label: 'Event Chair', value: 'event_chair', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'Notes', value: 'notes'},
                    { select_by_default: true, label: 'Description', value: 'description'},
                    { select_by_default: true, label: 'Income', value: 'workplan_income', type: 'number_between' },
                    { select_by_default: true, label: 'Expense', value: 'workplan_expense', type: 'number_between' },
                    { select_by_default: true, label: 'Tasks Due', value: 'tasks_due', type: 'date' },
                    { select_by_default: true, label: 'Goal Accomplished', value: 'goal_status', type: 'boolean' },

                    { select_by_default: true, label: "Created Date", value: "created_at", type: 'date' },
                    { select_by_default: true, label: "Updated Date", value: "updated_at", type: 'date' },
                    { select_by_default: true, label: "Involvement", value: "involvement", type: 'involvement' },
                    { select_by_default: true, label: "Related To Contact", value: "related_to_contact", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Business", value: "related_to_business", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Property", value: "related_to_property", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Work Plan", value: "related_to_workplan", type: 'select', multi_community: false },

                    { label: 'All', value: 'all', type: 'all' },
                ],
                availableAggregates: [
                    //
                ],
            },
            {
                name: "Donations",
                slug: 'donation',
                value: 'donations', // for api
                searchExpanded: false,
                displayExpanded: false,
                availableFields: [
                    { label: 'Donor (Contact)', value: 'contact_donor', type: 'select', multi_community: false },
                    { label: 'Donor (Business)', value: 'business_donor', type: 'select', multi_community: false },
                    { label: 'Anonymous', value: 'anonymous', type: 'boolean' },
                    // { label: 'Type', value: 'type', type: 'select', multi_community: false },
                    { label: 'Related To Campaign', value: 'campaign', type: 'select', multi_community: false },
                    { label: 'Amount', value: 'amount', type: 'number' },
                    { label: 'Has Fund', value: 'fund', type: 'select', multi_community: false },
                    { label: 'Has Appeal', value: 'appeal', type: 'select', multi_community: false },
                    // { label: 'Notes', value: 'notes' },
                    { label: 'Has Frequency', value: 'frequency', type: 'select', providedOptions: [
                        'Monthly',
                        'Quarterly',
                        'Yearly'
                    ] },
                    // { label: 'Number of Donations', value: 'num_donations' },
                    { label: 'Start Date', value: 'start_date', type: 'date' },
                    { label: 'Received Date', value: 'received_date', type: 'date' },
                    { label: 'Received', value: 'donation_received', type: 'boolean' },
                    { label: 'Has Donation Type', value: 'donation_type', type: 'select', providedOptions: [
                        'Single',
                        'Recurring',
                        'In Kind',
                    ] },

                    /*
                    { select_by_default: true, searchable: false, value: 'donation_id' },
                    { select_by_default: true, searchable: false, value: 'amount' },
                    { select_by_default: true, searchable: false, value: 'donation_date', type: 'date' },
                    { select_by_default: true, searchable: false, value: 'invoice_num' },
                    { select_by_default: true, searchable: false, value: 'received' },
                    { select_by_default: true, searchable: false, value: 'donation' },
                    */

                    // { select_by_default: true, label: "Created Date", value: "created_at", type: 'date' },
                    // { select_by_default: true, label: "Updated Date", value: "updated_at", type: 'date' },
                    // { select_by_default: true, label: "Involvement", value: "involvement", type: 'involvement' },
                    // { select_by_default: true, label: "Related To Contact", value: "related_to_contact", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Business", value: "related_to_business", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Property", value: "related_to_property", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Work Plan", value: "related_to_workplan", type: 'select', multi_community: false },

                    { label: 'All', value: 'all', type: 'all' },
                ],
                availableAggregates: [
                    //
                ],
            },
            {
                name: "Volunteer Hours",
                slug: 'volunteer-hours',
                value: 'volunteer-hours', // for api
                searchExpanded: false,
                displayExpanded: false,
                availableFields: [
                    // { select_by_default: true, label: "Related To Contact", value: "related_to_contact", type: 'select', multi_community: false },
                    // { select_by_default: true, label: 'Contact', value: 'contact', type: 'select', multi_community: false },
                    // { searchable: false, select_by_default: true, label: 'Contact ID', value: 'contact_id' },
                    { select_by_default: true, label: 'Is Staff', value: 'is_staff', type: 'boolean' },
                    { select_by_default: true, label: 'Time Taken', value: 'time_taken', type: 'number', step: 'any' },
                    { select_by_default: true, label: 'Date Volunteered', value: 'date_volunteered', type: 'date' },
                    // { select_by_default: true, label: 'Related Involvement', value: 'involvement' },
                    // { select_by_default: true, label: 'Related Task', value: 'task' },
                    { select_by_default: true, label: 'Notes', value: 'notes' },

                    // { select_by_default: true, label: "Created Date", value: "created_at", type: 'date' },
                    // { select_by_default: true, label: "Updated Date", value: "updated_at", type: 'date' },
                    { select_by_default: true, label: "Involvement", value: "involvement", type: 'involvement' },
                    { select_by_default: true, label: "Related To Contact", value: "related_to_contact", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Business", value: "related_to_business", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Property", value: "related_to_property", type: 'select', multi_community: false },
                    // { select_by_default: true, label: "Related To Work Plan", value: "related_to_workplan", type: 'select', multi_community: false },

                    { label: 'All', value: 'all', type: 'all' },
                ],
                availableAggregates: [
                    //
                ],
            },
            {
                name: "Volunteer Opportunities",
                slug: 'volunteer-opportunities',
                value: 'volunteer-opportunities', // for api
                searchExpanded: false,
                displayExpanded: false,
                availableFields: [
                    // { searchable: false, select_by_default: true, label: 'Opportunity ID', value: 'opportunity_id' },

                    { select_by_default: true, label: "Related To Event", value: "related_to_event", type: 'select', multi_community: false },
                    { select_by_default: true, label: "Related To Work Plan", value: "related_to_workplan", type: 'select', multi_community: false },
                    { select_by_default: true, label: "Sign Up Related To Contact", value: "sign_up_related_to_contact", type: 'select', multi_community: false },

                    { select_by_default: true, label: "Created Date", value: "created_at", type: 'date' },
                    { select_by_default: true, label: "Updated Date", value: "updated_at", type: 'date' },

                    /*
                    { select_by_default: true, label: 'Opportunity', value: 'opportunity', type: 'select', multi_community: false },
                    { select_by_default: true, label: 'Job', value: 'job' },
                    { select_by_default: true, label: 'Time Slot', value: 'time_slot' },
                    { select_by_default: true, label: 'First Name', value: 'first_name' },
                    { select_by_default: true, label: 'Last Name', value: 'last_name' },
                    { select_by_default: true, label: 'Email', value: 'email' },
                    { select_by_default: true, label: 'Phone', value: 'phone' },
                    */

                    { label: 'All', value: 'all', type: 'all' },
                ],
                availableAggregates: [
                    //
                ],
            },
            {
                name: "Overview",
                slug: 'overview',
                value: 'overview', // for api
                searchExpanded: false,
                displayExpanded: false,
                availableFields: [
                    { select_by_default: true, label: "Created Date", value: "created_at", type: 'date' },
                    { select_by_default: true, label: "Updated Date", value: "updated_at", type: 'date' },
                    { select_by_default: true, label: "Involvement", value: "involvement", type: 'involvement', objects: ['contacts', 'businesses', 'properties', 'work-plans'] },
                    { select_by_default: true, label: "Related To Contact", value: "related_to_contact", type: 'select', multi_community: false, objects: ['contacts', 'businesses', 'properties', 'work-plans'] },
                    { select_by_default: true, label: "Related To Business", value: "related_to_business", type: 'select', multi_community: false, objects: ['contacts', 'businesses', 'properties', 'work-plans'] },
                    { select_by_default: true, label: "Related To Property", value: "related_to_property", type: 'select', multi_community: false, objects: ['contacts', 'businesses', 'properties', 'work-plans'] },
                    // { select_by_default: true, label: "Related To Work Plan", value: "related_to_workplan", type: 'select', multi_community: false },
                ],
                availableAggregates: [
                    //
                ],
            },
            // Overview
        ],

        searchTerms: [],
    }

    constructor(props) {
        super(props);

        // set author
        this.state.reportInfo.author = props.user.hasOwnProperty('contact') && props.user.contact ? props.user.contact.name : `${props.user.first_name} ${props.user.last_name}`;

        // set installs
        if(props.user.installs.length) {
            let availableCommunities = [];
            let selectedCommunities = [];

            for(const install of props.user.installs) {
                let installName = install.name;
                if(!install.active) {
                    installName += ' (Inactive)';
                }

                availableCommunities.push({label: installName, value: install.subdomain});
            }

            // todo: determine if this check is sufficient for conductor
            if(props.user.hasOwnProperty('current_install') && props.user.current_install !== null) {
                selectedCommunities.push({label: props.user.current_install.name, value: props.user.current_install.subdomain});
            } else {
                // for conductor, we select all so that quick searches don't break
                selectedCommunities = availableCommunities;
            }

            this.state.availableCommunities = availableCommunities;
            if(selectedCommunities.length) {
                this.state.selectedCommunities = selectedCommunities;
            }
        }

        // check all objects by default
        // this.state.selectedObjects = this.state.objects;
    }

    componentDidMount() {
        const { state } = this.props.location;
        if(state) {
            const {quickReport = null, savedSearch = null} = state;
            if(quickReport) {
                this.buildQuickReport(quickReport);
            } else if(savedSearch) {
                this.buildSavedSearch(savedSearch);
            }
        }
    }

    findAndSetCommunities = (communities) => {
        return new Promise((resolve, reject) => {

            let selectedCommunities = [];

            for(const community of this.state.availableCommunities) {
                if(communities.indexOf(community.value) !== -1) {
                    selectedCommunities.push(community);
                }
            }

            this.setState({selectedCommunities}, () => {resolve()});
        });
    };
    findAndSetDateRange = (label) => {
        return new Promise((resolve, reject) => {
            for(const dateRangePreset of dateRangePresets) {
                if(label == dateRangePreset.label) {
                    let aggregateDateRange = this.state.aggregateDateRange;
                    aggregateDateRange.startDate = dateRangePreset.startDate;
                    aggregateDateRange.endDate = dateRangePreset.endDate;
                    this.setState({aggregateDateRange}, () => {resolve()});
                    break;
                }
            }
        });
    };
    findAndSetAggregates = (slugs) => {
        return new Promise((resolve, reject) => {
            if(slugs !== true && !Array.isArray(slugs)) {
                slugs = [slugs];
            }

            let selectedAggregates = [];
            for(const aggregate of this.state.allAggregates) {
                if(slugs === true || slugs.indexOf(aggregate.value) !== -1) {
                    selectedAggregates.push(aggregate);
                }
            }
            this.setState({selectedAggregates}, () => {resolve()});
        });
    };
    findAndSetFilteredObjects = (objects) => {
        let includedFilteredObjects = [];

        for(const filterableObject of this.state.filterableObjects) {
            if(objects.indexOf(filterableObject.slug) !== -1) {
                includedFilteredObjects.push(filterableObject);
            }
        }

        return new Promise((resolve, reject) => {
            this.setState({includedFilteredObjects}, () => {resolve()});
        });
    };
    generateSearchTerms = (terms) => {
        let searchTerms = [];
        for(const term of terms) {
            for(const availableObject of this.state.objects) {
                if(term.object === availableObject.slug) {
                    let searchGroup = {
                        object: availableObject,
                        possibleOptions: availableObject.availableFields.map(field => {field.type = field.type || 'contains'; return field}),//.filter(field => field.hasOwnProperty('type'));,
                        options: term.options
                    }

                    searchTerms.push(searchGroup);
                }
            }
        }

        return new Promise((resolve, reject) => {
            this.setState({searchTerms}, () => {resolve()});
        });
    };
    generateSearchTermsFromSaved = (terms) => {
        let searchTerms = [];
        // TODO: convert overviews back (check if object length == ovierviews, then check if the filters are the same across all of them)

        // console.log(terms);
        // length needs to be available - 1 (since overview counts as one)
        // we use divisible by in case there's multiple overviews
        if(terms.length % (this.state.objects.length - 1) === 0) {
            const chunkSize = (this.state.objects.length - 1);
            for (let i = 0; i < terms.length; i += chunkSize) {
                const chunk = terms.slice(i, i + chunkSize);
                // console.log(chunk);

                if(chunk[0].options.type === chunk[1].options.type) {
                    // console.log('IS AN OVERVIEW');
                    let term = chunk[0];

                    for(const availableObject of this.state.objects) {
                        if(availableObject.value === 'overview') {
                            let searchGroup = {
                                object: availableObject,
                                possibleOptions: availableObject.availableFields.map(field => {field.type = field.type || 'contains'; return field}),
                            };

                            let generatedOptions = [];
                            for(const opt of term.options) {
                                let searchObject = {
                                    ...opt,
                                };

                                for(const field of availableObject.availableFields) {
                                    if(field.value === opt.type) {
                                        let fieldType = field.type || 'contains';

                                        if(fieldType === 'all') {
                                            searchObject.operators = {};
                                            generatedOptions.push(searchObject);
                                            break;
                                        }

                                        if(fieldType === 'select') {
                                            // do nothing (the additional handling happens inside of MaestroSearchSelect)
                                        } else if(fieldType === 'date' || fieldType === 'relative_date') {
                                            // do nothing
                                        } else {
                                            let operators = multiSearchOperators[fieldType];
                                            searchObject.operators = operators;

                                            let optionsForSelect = objectToSelectOptions(operators);
                                            for(const optionForSelect of optionsForSelect) {
                                                if(optionForSelect.value === opt.operator) {
                                                    searchObject.operator = optionForSelect;
                                                    break;
                                                }
                                            }
                                        }
                                        
                                        // only push if not 'all' (already pushed above)
                                        if(fieldType !== 'all') {
                                            generatedOptions.push(searchObject);
                                        }
                                        break;
                                    }
                                }
                            }

                            searchGroup.options = generatedOptions;
                            searchTerms.push(searchGroup);
                            // value: 'overview', // for api
                        }
                    }
                }
            }


            return new Promise((resolve, reject) => {
                this.setState({searchTerms}, () => {resolve()});
            });
        }

        for(const term of terms) {
            for(const availableObject of this.state.objects) {
                if(term.name === availableObject.value) {
                    let searchGroup = {
                        object: availableObject,
                        possibleOptions: availableObject.availableFields.map(field => {field.type = field.type || 'contains'; return field}),
                    };

                    let generatedOptions = [];
                    for(const opt of term.options) {
                        let searchObject = {
                            ...opt,
                        };

                        for(const field of availableObject.availableFields) {
                            if(field.value === opt.type) {
                                let fieldType = field.type || 'contains';

                                // special handling for 'all'
                                if(fieldType === 'all') {
                                    searchObject.operators = {};
                                    generatedOptions.push(searchObject);
                                    break;
                                }
                                if(fieldType === 'select') {
                                    // do nothing (the additional handling happens inside of MaestroSearchSelect)
                                } else if(fieldType === 'date' || fieldType === 'relative_date') {
                                    // do nothing
                                } else {
                                    let operators = multiSearchOperators[fieldType];
                                    searchObject.operators = operators;

                                    let optionsForSelect = objectToSelectOptions(operators);
                                    for(const optionForSelect of optionsForSelect) {
                                        if(optionForSelect.value === opt.operator) {
                                            searchObject.operator = optionForSelect;
                                            break;
                                        }
                                    }
                                }

                                // only push if not 'all'
                                if(fieldType !== 'all') {
                                    generatedOptions.push(searchObject);
                                }
                                break;
                            }
                        }
                    }

                    searchGroup.options = generatedOptions;
                    searchTerms.push(searchGroup);
                }
            }
        }

        return new Promise((resolve, reject) => {
            this.setState({searchTerms}, () => {resolve()});
        });
    };
    buildQuickReport = async (slug) => {
        if(slug === 'net-new-biz-this-year') {
            await this.findAndSetDateRange('This Year').catch(e => console.log(e));
            await this.findAndSetAggregates(['new_businesses']).catch(e => console.log(e));
        }
        else if(slug === 'total-assessed-market-value') {
            await this.findAndSetDateRange('All Time').catch(e => console.log(e));
            await this.findAndSetAggregates(['assessed_market_value']).catch(e => console.log(e));
        }
        else if(slug === 'reinvestment-stats-this-month') {
            await this.findAndSetDateRange('This Month').catch(e => console.log(e));
            await this.findAndSetAggregates(true).catch(e => console.log(e));
        }
        else if(slug === 'reinvestment-stats-this-quarter') {
            await this.findAndSetDateRange('This Quarter').catch(e => console.log(e));
            await this.findAndSetAggregates(true).catch(e => console.log(e));
        }
        else if(slug === 'reinvestment-stats-this-year') {
            await this.findAndSetDateRange('This Year').catch(e => console.log(e));
            await this.findAndSetAggregates(true).catch(e => console.log(e));
        }
        else if(slug === 'reinvestment-stats-all-time') {
            await this.findAndSetDateRange('All Time').catch(e => console.log(e));
            await this.findAndSetAggregates(true).catch(e => console.log(e));
        }
        else if(slug === 'all-property-owners') {
            await this.generateSearchTerms([
                {
                    object: 'contact',
                    options: [
                        {
                            "type": "owned_properties",
                            "operator": {
                                "label": "Greater Than",
                                "value": ">"
                            },
                            "value": "0",
                            // todo: see if the operators will work like this or if we have to figure out how to pass the referenced obj
                            "operators": {
                                ">": "Greater Than",
                                "<": "Less Than",
                                "=": "Equals",
                                "!=": "Does Not Equal"
                            }
                        }
                    ]
                },
                {
                    object: 'business',
                    options: [
                        {
                            "type": "owned_properties",
                            "operator": {
                                "label": "Greater Than",
                                "value": ">"
                            },
                            "value": "0",
                            // todo: see if the operators will work like this or if we have to figure out how to pass the referenced obj
                            "operators": {
                                ">": "Greater Than",
                                "<": "Less Than",
                                "=": "Equals",
                                "!=": "Does Not Equal"
                            }
                        }
                    ]
                }
            ]);
        }
        else if(slug === 'all-business-owners') {
            await this.generateSearchTerms([
                {
                    object: 'business',
                    options: [
                        {
                            "type": "all",
                            "operator": "=",
                            "value": "",
                            "operators": {}
                        }
                    ]
                }
            ]);
            await this.findAndSetFilteredObjects(['contact']);
        }
        else if(slug === 'active-businesses') {
            await this.generateSearchTerms([
                {
                    object: 'business',
                    options: [
                        {
                          "type": "not_in_district",
                          "operator": {
                                "label": "Yes",
                                "value": "true"
                          },
                          "value": "",
                          "operators": {
                                "true": "Yes",
                                "false": "No"
                          }
                        },
                        {
                            "type": "is_closed",
                            "operator": {
                                  "label": "No",
                                  "value": "false"
                            },
                            "value": "",
                            "operators": {
                                  "true": "Yes",
                                  "false": "No"
                            }
                          },
                          {
                            "type": "is_moved_out",
                            "operator": {
                                  "label": "No",
                                  "value": "false"
                            },
                            "value": "",
                            "operators": {
                                  "true": "Yes",
                                  "false": "No"
                            }
                          }
                    ]
                }
            ]);
            //
        } else if(slug === 'veteran-demographic' || slug === 'minority-demographic' || slug === 'female-demographic' || slug === 'lgbt-demographic') {
            let demographicTerm = 'is_'+slug.replace('-demographic', '');

            await this.generateSearchTerms([
                {
                    object: 'contact',
                    options: [
                        {
                            "type": demographicTerm,
                            "operator": {
                                  "label": "Yes",
                                  "value": "true"
                            },
                            "value": "",
                            "operators": {
                                  "true": "Yes",
                                  "false": "No"
                            }
                        },
                    ]
                },
                {
                    object: 'business',
                    options: [
                        {
                            "type": demographicTerm,
                            "operator": {
                                  "label": "Yes",
                                  "value": "true"
                            },
                            "value": "",
                            "operators": {
                                  "true": "Yes",
                                  "false": "No"
                            }
                        },
                    ]
                },
                {
                    object: 'property',
                    options: [
                        {
                            "type": demographicTerm,
                            "operator": {
                                  "label": "Yes",
                                  "value": "true"
                            },
                            "value": "",
                            "operators": {
                                  "true": "Yes",
                                  "false": "No"
                            }
                        },
                    ]
                }
            ]);
        } else {
            return; // don't remove this or runSearch will run without a proper quick report
        }

        // run search
        this.runSearch();
    }

    buildSavedSearch = async (savedSearch) => {
        // console.log(savedSearch);
        await this.findAndSetCommunities(savedSearch.communities);
        await this.findAndSetAggregates(savedSearch.aggregates);

        // await this.findAndSetDateRange(savedSearch.communities);
        await new Promise((resolve, reject) => {
            let aggregateDateRange = this.state.aggregateDateRange;
            aggregateDateRange.startDate = parseISO(savedSearch.start_date);
            aggregateDateRange.endDate = parseISO(savedSearch.end_date);
            this.setState({aggregateDateRange}, () => {resolve()});
        });

        // todo: detect if it's an overview
        await this.generateSearchTermsFromSaved(savedSearch.filters);

        // todo: detect if it's an overview
        await this.findAndSetFilteredObjects(savedSearch.filtered_objects);

        // run search
        this.runSearch();
    };

    changeSelectedCommunities = (selected, event) => {
        this.setState({
            selectedCommunities: selected,
            searchTerms: [],
        });
    }

    getFieldsCommonToSelectedObjects = () => {
        return [];
        //
    };

    determineInvalidOptionsFromSelectedObjects = (selected) => {
        return []; // ['Anniversary', 'Birthday']; // todo
    };

    changeIncludedFilteredObjects = (selected, event) => {
        this.setState({includedFilteredObjects: selected});
    };

    changeSelectedObjects = (selected, event) => {
        if(event.action !== 'select-option') {
            this.setState({selectedObjects: selected}, () => {
                let selectedDisplayFields = this.state.selectedDisplayFields;

                if(!event.hasOwnProperty('removedValues') && !event.hasOwnProperty('removedValue')) {
                    console.error('event missing removedValue(s)');
                    console.error(event);
                    return;
                }

                let removedValues = event.hasOwnProperty('removedValues') ? event.removedValues : [event.removedValue];
                for(let removedValue of removedValues) {
                    /*
                    let fieldsForObject = this.getAllFields('display').find(row => row.label === removedValue.name);
                    if(!fieldsForObject) {
                        return;
                    }
                    */

                    selectedDisplayFields = selectedDisplayFields.filter(entry => entry.value.indexOf(`${removedValue.slug}.`) === -1);
                }

                this.setState({selectedDisplayFields});
            });

            // todo: remove objects that are no longer valid
            // changeSelectedObjects

            return;
        }

        const newlySelected = event.option.name;
        const conflicts = this.determineInvalidOptionsFromSelectedObjects(selected);

        if(conflicts.length) {
            if(global.confirm(`Selecting ${newlySelected} will require unchecking the following fields: ${conflicts.join(', ')}. Continue?`)) {
                this.setState({selectedObjects: selected});
            }
            // console.log('NOTE: selected object will cause issues with previously selected ');
        } else {
            this.setState({selectedObjects: selected}, () => {
                // add default checked fields
                let fieldsForObject = this.getAllFields('display').find(row => row.label === event.option.name);
                if(!fieldsForObject) {
                    return;
                }

                let toSelectByDefault = fieldsForObject.options.filter(field => field.hasOwnProperty('select_by_default') && field.select_by_default);
                if(!toSelectByDefault.length) {
                    return;
                }

                let selectedDisplayFields = this.state.selectedDisplayFields;
                for(let toSelect of toSelectByDefault) {

                    let found = false;
                    for(let selectedField of selectedDisplayFields) {
                        if(selectedField.value == toSelect.value) {
                            found = true;
                            break;
                        }
                    }
                    // this probably isn't sufficient
                    if(!found) {
                        selectedDisplayFields.push(toSelect);
                    }
                    /*
                    if(selectedDisplayFields.indexOf(toSelect) === -1) {
                        selectedDisplayFields.push(toSelect);
                    }
                    */
                }


                this.setState({selectedDisplayFields});
            });
        }
    }

    getAllFields = (type) => {
        let fieldGroups = [];

        for(const object of this.state.selectedObjects) {
            const availableFields = JSON.parse(JSON.stringify(object.availableFields.filter(o => !o.hasOwnProperty('searchable') || o.searchable === true)));
            const defaultFields = JSON.parse(JSON.stringify(this.state.defaultFields));
            const options = [...availableFields, ...defaultFields];

            options.forEach(option => {
                option.value = object.slug+"."+option.value;
            })

            let newObject = {
                label: object.name,
                options: options,
            };

            if(type === 'search') {
                newObject.expanded = object.searchExpanded;
            } else if(type === 'display') {
                newObject.expanded = object.displayExpanded;
            }

            fieldGroups.push(newObject);
        }

        fieldGroups.sort(function(a, b) {
            return ('' + a.name).localeCompare(b.name);
        });

        return fieldGroups;
    }

    getAllDateFields = () => {
        let dateFields = {};
        for(const object of this.state.objects) {
            for(const field of object.availableFields) {
                if(field.hasOwnProperty('type') && (field.type === 'date' || field.type === 'relative_date')) {
                    dateFields[field.value] = 1;
                }
            }
        }

        return dateFields;
    }

    changeSelectedDisplayFields = (selected, event) => {
        this.setState({selectedDisplayFields: selected});
    }

    changeSelectedAggregates = (selected, event) => {
        this.setState({selectedAggregates: selected});
    }

    changeAggregateDateRange = (ranges) => {
        const {aggregateDateRange} = this.state;
        aggregateDateRange.startDate = ranges.selection.startDate;
        aggregateDateRange.endDate = ranges.selection.endDate;
        this.setState({aggregateDateRange});
    }

    changeAggregateStatsOnly = (toggled) => {
        this.setState({
            aggregateStatsOnly: toggled,
        });
    }

    changeReportInfo = (reportInfo) => {
        this.setState({reportInfo});
    }

    toggleFieldGroup = (group, type) => {
        const objects = this.state.objects;
        for(const object of objects) {
            if(object.name === group.label) {
                if(type === 'search') {
                    object.searchExpanded = !object.searchExpanded;
                } else if (type === 'display') {
                    object.displayExpanded = !object.displayExpanded;
                }
                break;
            }
        }

        this.setState({objects});
    };

    toggleSearchFieldGroup = (group) => {
        this.toggleFieldGroup(group, 'search');
    };

    toggleDisplayFieldGroup = (group) => {
        this.toggleFieldGroup(group, 'display');
    };

    getUserInstallCount = () => {
        try {
            return this.props.user.installs.length;
        } catch(e) {
            return 0;
        }
    }

    runSearch = () => {
        this.setState({
            loading: true,
            result: null,
        });

        // ensure that end date is after start date
        if(isAfter(this.state.aggregateDateRange.startDate, this.state.aggregateDateRange.endDate)) {
            alert('The report end date must be after the start date.');
            this.setState({loading: false});
            return;
        }


        let records = {}; //this.state.selectedDisplayFields.map(comm => comm.value);

        // const displayFields = [...this.state.selectedDisplayFields];
        const displayFields = JSON.parse(JSON.stringify(this.state.selectedDisplayFields));

        // TODO: transform relationships to include same fields (e.g. contact w/ first,last,spouse should only return spouse first,last)
        displayFields.forEach(row => {

            let val = row.value;//.replace('contact.', 'contacts.')

            for(let obj of this.state.objects) {
                val = val.replace(`${obj.slug}.`, `${obj.value}.`);
            }

            records[val] = true;
        });

        function deepen(obj) {
            const result = {};

            // For each object path (property key) in the object
            for (const objectPath in obj) {
              // Split path into component parts
              const parts = objectPath.split('.');

              // Create sub-objects along path as needed
              let target = result;
              while (parts.length > 1) {
                const part = parts.shift();
                target = target[part] = target[part] || {};
              }

              // Set value at end of path
              target[parts[0]] = obj[objectPath]
            }

            return result;
        }

        /*
        this.state.selectedDisplayFields.forEach(row => {
            let splitProp = row.value.split('.');
            if(!records.hasOwnProperty(splitProp[0])) {
                records[splitProp[0]] = [];
            }

            records[splitProp[0]].push(splitProp[1]);
        })
        */

        let selectedObjects = {};
       this.state.selectedObjects.map(comm => selectedObjects[comm.value] = 1);

       let includedFilteredObjects = {};
       this.state.includedFilteredObjects.map(comm => includedFilteredObjects[comm.value] = 1);

        const allDateFields = this.getAllDateFields();
        let generatedSearchTerms = [];

        for(const searchTerm of this.state.searchTerms) {
            /*
            let options = [...searchTerm.options];
            console.log(options);

            options.map((option, optionIndex) => {
                console.log(option);
                if(typeof option.operator === 'object') {
                    option.operator = option.operator.value;
                }
                delete option.operators;
            });
            */

            let foundAnError = false;
            let options = [];
            searchTerm.options.map((option, optionIndex) => {
                let value;

                if(allDateFields.hasOwnProperty(option.type)) {
                    value = formatDateForRequest(this.state.aggregateDateRange.startDate);
                }
                else if(option.operator && option.operator.value == 'true') {
                    value = 1;
                } else if(option.operator && option.operator.value == 'false') {
                    value = 0;
                } else if(typeof option.value === 'object') {
                    if(option.value instanceof Date) {
                        value = option.value;
                    } else {
                        if(option.value == null) {
                            foundAnError = 'Empty search filter';
                            // this.setState({loading: false});
                            return;
                        }
                        // console.log(option.value);
                        value = option.value.value;
                    }
                } else {
                    value = option.value;
                }

                let generatedOption = {
                    type: option.type,
                    operator: (typeof option.operator === 'object') ? option.operator.value : option.operator,
                    value: value,//typeof option.value === 'object' ? option.value.value : option.value,
                };
                if(allDateFields.hasOwnProperty(option.type)) {
                    generatedOption.operator = 'between';
                    generatedOption.value2 = formatDateForRequest(this.state.aggregateDateRange.endDate);
                }
                else if(option.hasOwnProperty('value2')) {
                    let value2 = null;

                    if(option.value2 === null) {
                        //
                    }
                    else if(typeof option.value2 === 'object') {
                        if(option.value2 instanceof Date) {
                            value2 = option.value2;
                        } else {
                            value2 = option.value2.value;
                        }
                    } else if(option.value2) {
                        value2 = option.value2;
                    }

                    generatedOption.value2 = value2;//option.value2;
                }

                // for searching involvement by name
                /*
                if(this.state.selectedCommunities.length > 1 && option.type === 'involvement') {
                    generatedOption.value_name = option.value.label;
                }
                */

                options.push(generatedOption);
                // console.log(generatedOption);
                // if(typeof option.operator === 'object') {
                    // option.operator = option.operator.value;
                // }
                // delete option.operators;
            });

            // this.setState({loading: false});
            // return;

            // don't run searches when the filter wasn't set up correctly
            if(!searchTerm.object || foundAnError !== false) {
                this.setState({loading: false});
                return;
            }

            let generatedTerm = {
                name: searchTerm.object.value,
                options: options,//searchTerm.options,
            };

            // add separate searches for all overview items
            if(searchTerm.object.value === 'overview') {
                /*
                for(const opt of generatedTerm.options) {
                    let objectsToAdd = opt.hasOwnProperty('objects') ? opt.objects : this.state.objects.map(obj => obj.value);
                }
                */
                // console.log(searchTerm);
                // console.log(objectsToAdd);
                // return;

                const objectsToAdd = this.state.objects.map(obj => obj.value);
                for(const obj of objectsToAdd) {
                    if(obj !== 'overview') {
                        let clonedTerm = {...generatedTerm};
                        clonedTerm.name = obj;
                        generatedSearchTerms.push(clonedTerm);
                        selectedObjects[obj] = 1;
                    }
                }
            } else {
                generatedSearchTerms.push(generatedTerm);
            }

            // console.log(generatedSearchTerms);
        }

        let request = {
            communities: this.state.selectedCommunities.map(comm => comm.value),
            objects: Object.keys(selectedObjects),
            records: deepen(records),
            aggregates: this.state.selectedAggregates.map(comm => comm.value),
            filters: generatedSearchTerms,//this.state.searchTerms,
            filtered_objects: this.hasOverviewSearchTerm() ? [] : includedFilteredObjects,

            start_date: formatDateForRequest(this.state.aggregateDateRange.startDate),
            end_date: formatDateForRequest(this.state.aggregateDateRange.endDate),
        };

        authenticatedApi.post('reports', request/*{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        }*/).then(response => {
            events.reportRan();
            // console.log(response.data);

            /*
            reportInfo: {
                communityName: '',
                name: '',
                author: this.props.user.name,
                description: '',
            },
            */

            const {reportInfo} = this.state;

            // set reportinfo community name
            let maxLen = 3;
            let communityName = '';
            for(let i = 0; i < this.state.selectedCommunities.length; i++) {
                if(i == maxLen) {
                    let remaining = this.state.selectedCommunities.length - i;
                    if(remaining === 1) {
                        communityName += `, and one other`;
                    } else {
                        communityName += `, and ${remaining} others`;
                    }
                    break;
                } else if(i > 0) {
                    communityName += ', ';
                }
                communityName += this.state.selectedCommunities[i].label;
                if(i == maxLen) {
                    break;
                }
            }
            reportInfo.communityName = communityName;

            // set report info name
            if(!this.state.selectedAggregates.length) {
                reportInfo.name = 'Maestro Search '+(format(new Date(), 'MM/dd/yyyy'));
            }
            else if(getYear(this.state.aggregateDateRange.startDate) === 1001) {
                reportInfo.name = 'All-time as of '+(format(new Date(), 'MM/dd/yyyy'));
                // reportInfo.description = 'Generated on '+(format(new Date(), 'MM/dd/yyyy \a\t hh:mm aa'));
            } else {
                reportInfo.name = `Report from ${format(this.state.aggregateDateRange.startDate, 'MM/dd/yyyy')} to ${format(this.state.aggregateDateRange.endDate, 'MM/dd/yyyy')}`;
                reportInfo.description = 'Generated on '+(format(new Date(), "MM/dd/yyyy 'at' hh:mm aa"));
            }

            /*
            if(request.communities.length === 1) {
                reportInfo.communityName = this.state.selectedCommunities[0].name;
            } else {
                let communityNames = '';
                for(let i = 0; i < this.state.selectedCommunities.length; i++) {
                    if(i > 0) {
                        communityNames += ', ';
                    }
                    if(i == 5) {
                        let remaining = this.state.selectedCommunities.length - i;
                        if(remaining === 1) {
                            communityNames += `, and one other`;
                        } else {
                            communityNames += `, and ${remaining} others`;
                        }
                        break;
                    }
                    communityNames += this.state.selectedCommunities[i].name;
                    if(i == 5) {
                        break;
                    }
                }

                reportInfo.communityName = communityNames;//`${request.communities.length} ${request.communities.length === 1 ? 'Community' : 'Communities'}`
            }
            */

            let {_meta, ...result} = response.data;

            result.options = {
                communities: [...this.state.selectedCommunities],
                aggregates: [...this.state.allAggregates],
                statsOnly: this.state.aggregateStatsOnly,
                searchTerms: [...this.state.searchTerms],
                meta: _meta,

                request: request, // this is used for saving
            };

            this.setState({
                reportInfo,
                result: result
            });
        }).catch(e => {
            console.log(e);
            this.setState({result: {error: e}});
        }).finally(() => {
            this.setState({loading: false});
        });
    };


    // MemoReportResults = () => (<div/>)
    MemoReportResults = React.memo(({selectedCommunities, allAggregates, reportInfo, changeReportInfo, result, searchTerms}) => (
        <ReportResults
                                // communities={selectedCommunities}
                                // aggregates={allAggregates}
                                reportInfo={reportInfo}
                                changeReportInfo={changeReportInfo}
                                result={result}
                                // searchTerms={searchTerms}
                            />
    ));

    hasOverviewSearchTerm = () => {
        for(const term of this.state.searchTerms) {
            try {
                if(term.object.value === 'overview') {
                    return true;
                }
            } catch(e){}
        }

        return false;
    }

    render() {
        return (
            <Box sx={{
                display: 'flex',
                '--mm-settings-sidebar-width': 'max(300px, 25vw)',
            }}>
                <Box sx={{
                    position: 'fixed',
                    left: {
                        md: '70px',
                    },
                    top: 'var(--Header-height)',
                    bottom: 0,
                    width: 'var(--mm-settings-sidebar-width)',
                    // flex: '0 0 20vw',
                    height: 'calc(100vh - var(--Header-height))',
                    overflowY: 'auto',
                    scrollbarWidth: 'thin',
                    borderRight: 1,
                    borderColor: 'var(--joy-palette-divider)',
                    // borderRightColor: 'palette.neutral.plainHoverBg',
                    //theme.palette.neutral.plainHoverBg,
                    // p: 2,
                }}>
                <Box sx={{
                    height: 'calc(100vh - var(--Header-height))',
                    // p: 2,
                    // overflowY: 'auto',
                    // scrollbar
                }}>
                    <AccordionGroup
                        sx={{
                        '.MuiAccordionSummary-button': {
                            fontWeight: 'bold',
                            py: 1.5,
                            // pb: 1.5,//0.75,
                            bgcolor: 'neutral.200',
                            color: '#000',
                            '&:hover': {
                                bgcolor: 'neutral.100',
                            },
                        },
                        '.MuiAccordionDetails-content.Mui-expanded': {
                            // marginTop: '2rem',
                            // paddingBlockStart: 'calc(2.5 * var(--ListItem-paddingY))',
                            // paddingBlockStart: 'calc(4 * var(--ListItem-paddingY))',
                            // paddingBlockEnd: 'calc(4 * var(--ListItem-paddingY))',
                            paddingBlockStart: 'calc(4 * var(--ListItem-paddingY))',
                            paddingBlockEnd: 'calc(4 * var(--ListItem-paddingY))',
                            // paddingBlockStart: '0.625rem !important',
                        }
                    }}
                    >
                    {this.getUserInstallCount() > 1 && (
                        <Accordion defaultExpanded>
                            <AccordionSummary>
                                <Box>
                                    Search These Communities {this.state.selectedCommunities.length > 0 && (<Chip color="primary" variant="solid" size="sm">{this.state.selectedCommunities.length}</Chip>)}
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <MaestroSelect
                                    options={this.state.availableCommunities}
                                    value={this.state.selectedCommunities}
                                    onChange={this.changeSelectedCommunities}
                                    // onToggleGroup={this.toggleGroup}
                                    showCheckboxes={true}
                                    showValueSummary={['Community', 'Communities']}
                                    allowSelectAll={true}
                                />
                                {this.state.searchTerms.length > 0 && <>
                                    <FormControl><FormHelperText>Note: Changing communities will reset your search terms.</FormHelperText></FormControl>
                                </>}
                            </AccordionDetails>
                        </Accordion>
                    )}

                    <Accordion defaultExpanded>
                        <AccordionSummary>Global Options</AccordionSummary>
                        <AccordionDetails>
                            <ToggleButtonGroup sx={{mb: 2}}>
                            {dateRangePresets.map((dateRangePreset, index) => {
                                let isSelected = isSameDay(this.state.aggregateDateRange.startDate, dateRangePreset.startDate) && isSameDay(this.state.aggregateDateRange.endDate, dateRangePreset.endDate);

                                return (
                                    <Button
                                        key={index}
                                        size='sm'
                                        // mr='3'
                                        aria-pressed={isSelected ? 'true' : 'false'}
                                        sx={(theme) => ({
                                        // take up the full space
                                        ...(index === 3 && {
                                            flex: 1
                                        }),
                                        [`&[aria-pressed="true"]`]: {
                                            ...theme.variants.outlinedActive.neutral,
                                            borderColor: theme.vars.palette.neutral.outlinedHoverBorder,
                                        },
                                        })}

                                        // colorScheme={isSelected ? 'brand' : 'gray'}
                                        onClick={() => {
                                            let aggregateDateRange = this.state.aggregateDateRange;
                                            aggregateDateRange.startDate = dateRangePreset.startDate;
                                            aggregateDateRange.endDate = dateRangePreset.endDate;
                                            this.setState({aggregateDateRange});
                                        }}
                                    >
                                        {dateRangePreset.label}
                                    </Button>
                                );
                            })}
                            </ToggleButtonGroup>

                            <Stack sx={{gap: 2, flexDirection: 'row', alignItems: 'center'}}>
                                <Box sx={{flex: 1}}>
                                    <DatePicker
                                        // locale="en-US"
                                        value={this.state?.aggregateDateRange?.startDate ? formatIso(this.state.aggregateDateRange.startDate) : ''}
                                        onChange={(event) => {
                                            let aggregateDateRange = this.state.aggregateDateRange;
                                            aggregateDateRange.startDate = parseISO(event.target.value);
                                            this.setState({aggregateDateRange});
                                        }}
                                        sx={{
                                            width: '100%'
                                        }}
                                    />
                                </Box>
                                <Box sx={{flex: 0}}><em>to</em></Box>
                                <Box sx={{flex: 1}}>
                                <DatePicker
                                    // locale="en-US"
                                    value={this.state?.aggregateDateRange?.endDate ? formatIso(this.state.aggregateDateRange.endDate) : ''}
                                    onChange={(event) => {
                                        let aggregateDateRange = this.state.aggregateDateRange;
                                        aggregateDateRange.endDate = parseISO(event.target.value);
                                        this.setState({aggregateDateRange});
                                    }}
                                    sx={{
                                        width: '100%'
                                    }}
                                />
                                </Box>
                            </Stack>

                        {/* </div> */}
                        {/* <div class="panel-subheading">Statistics</div> */}
                        {/* <div className="panel-body wrapper"> */}

                            <Divider
                                sx={{
                                    mt: 2,
                                    mx: 'calc(var(--ListItem-paddingLeft) * -1)'
                                }}
                            />

                            <FormControl>
                                <Box display='flex' alignItems='center' mt={2} gap={1}>
                                    <Switch id='stats-only' isChecked={this.state.aggregateStatsOnly} onChange={event => this.changeAggregateStatsOnly(event.target.checked)}/>
                                    <FormLabel htmlFor='stats-only' sx={{mb: 0}}>
                                        Only Display Statistics?
                                    </FormLabel>
                                </Box>
                                {/* <FormHelperText>If you choose this option, only an overview will be provided.</FormHelperText> */}
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>


                        {/*
                        In this date range:
                        <MaestroDateRangePicker
                            onChange={this.changeAggregateDateRange}
                            ranges={[this.state.aggregateDateRange]}
                        />
                        */}

                    {/*
                    <div className="panel widget">
                        <div className="panel-heading">
                            Search These Objects
                        </div>
                        <div className="panel-body wrapper">
                            <MaestroSelect
                                options={this.state.objects}
                                getOptionLabel={(option)=>option.name}
                                getOptionValue={(option)=>option.slug}
                                isMulti={true}
                                value={this.state.selectedObjects}
                                onChange={this.changeSelectedObjects}
                                showCheckboxes={true}
                            />
                            {/*
                            // TODO: FIX THIS (probably requires normalizing object & aggregate label/value)
                            <MaestroSelect
                                options={this.state.objects}
                                getOptionLabel={(option)=>option.name}
                                getOptionValue={(option)=>option.slug}
                                isMulti={true}
                                value={this.state.selectedObjects}
                                onChange={this.changeSelectedObjects}
                                showCheckboxes={true}
                                showValueSummary={['Object', 'Objects']}
                                allowSelectAll={true}
                            />
                            *\/}
                        </div>

                        {/*
                        // this is commented because there are too many issues with
                        // incorrect / not all fields being selected. we can
                        // re-enable this in a later push
                        {this.state.selectedObjects.length > 0 && <>
                            <div className="panel-subheading">
                                Include these fields:
                            </div>
                            <div className="panel-body wrapper">
                            <MaestroSelect
                                options={this.getAllFields('display')}
                                value={this.state.selectedDisplayFields}
                                onChange={this.changeSelectedDisplayFields}
                                onToggleGroup={this.toggleDisplayFieldGroup}
                                showCheckboxes={true}
                                showValueSummary={['Field', 'Fields']}
                                noOptionsMessage={()=>(
                                    this.state.selectedObjects.length
                                    ? 'No Options (Try Deselecting Objects)'
                                    : 'No Options (Select Objects First)'
                                )}
                            />
                        </div>
                        </>}
                        *\/}
                    </div>
                    */}

                    {/*
                    <div className="panel widget">
                        <div className="panel-heading">
                            Include These Fields:
                        </div>
                        <div className="panel-body wrapper">
                            <MaestroSelect
                                options={this.getAllFields('display')}
                                value={this.state.selectedDisplayFields}
                                onChange={this.changeSelectedDisplayFields}
                                onToggleGroup={this.toggleDisplayFieldGroup}
                                showCheckboxes={true}
                                showValueSummary={['Field', 'Fields']}
                                noOptionsMessage={()=>(
                                    this.state.selectedObjects.length
                                    ? 'No Options (Try Deselecting Objects)'
                                    : 'No Options (Select Objects First)'
                                )}
                            />
                        </div>
                    </div>
                    */}

                    <Accordion
                        defaultExpanded
                    >
                        <AccordionSummary>
                            <Box>
                                Search Filters {this.state.searchTerms.length > 0 && (<Chip color="primary" variant="solid" size="sm">{this.state.searchTerms.length}</Chip>)}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>

                    {/* {this.state.selectedObjects.length > 0 && <> */}
                    {/* <div className="mm-panel has-cards search-options"> */}
                    <MaestroMultiSearch
                        selectedCommunities={this.state.selectedCommunities}
                        objects={this.state.objects}
                        searchTerms={this.state.searchTerms}
                        dateRange={this.state.aggregateDateRange}
                        onChange={(searchTerms) => this.setState({searchTerms})}
                    />
                    {/* </div> */}
                    {/* </>} */}

                    {this.state.searchTerms.length > 0 && <>
                        <Card sx={{mt: 2, borderRadius: 'sm'}}>
                            <CardOverflow sx={{ bgcolor: 'background.level2' }}>
                                <CardActions sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    py: 1.7, // this is to make the height seem the same as the filter boxes
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        flex: 1,
                                        gap: 1,
                                    }}>
                                        <Typography fontWeight={'bold'} color="black">Include Filtered Objects</Typography>
                                    </Box>
                                </CardActions>
                            </CardOverflow>
                            <CardContent>
                                <Box>
                                {this.hasOverviewSearchTerm() === true && <em style={{fontStyle: 'italic'}}>This feature is unavailable on "overview" searches.</em>}

                                {this.hasOverviewSearchTerm() !== true && (
                                    <MaestroSelect
                                        options={this.state.filterableObjects}
                                        getOptionLabel={(option)=>option.name}
                                        getOptionValue={(option)=>option.slug}
                                        isMulti={true}
                                        value={this.state.includedFilteredObjects}
                                        onChange={this.changeIncludedFilteredObjects}
                                        showCheckboxes={true}
                                    />
                                )}
                                </Box>
                            </CardContent>
                        </Card>
                    </>}
                    </AccordionDetails>
                        </Accordion>

                    <Accordion defaultExpanded>
                        <AccordionSummary>
                            <Box>
                            Include Reinvestment Statistics? {this.state.selectedAggregates.length > 0 && (<Chip color="primary" variant="solid" size="sm">{this.state.selectedAggregates.length}</Chip>)}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MaestroSelect
                                options={this.state.allAggregates}
                                value={this.state.selectedAggregates}
                                onChange={this.changeSelectedAggregates}
                                showCheckboxes={true}
                                showValueSummary={['Statistic', 'Statistics']}
                                allowSelectAll={true}
                            />

                            {this.state.selectedAggregates.length > 0 && (<>
                                <FormControl><FormHelperText>Note: Search filters affect reinvestment statistics</FormHelperText></FormControl>
                                {/* <hr/> */}
                                {/*
                                In this date range:
                                <MaestroDateRangePicker
                                    onChange={this.changeAggregateDateRange}
                                    ranges={[this.state.aggregateDateRange]}
                                />
                                <hr/>
                                */}

                                {/*
                                <FormControl display='flex' alignItems='center'>
                                    <Switch id='stats-only' isChecked={this.state.aggregateStatsOnly} onChange={event => this.changeAggregateStatsOnly(event.target.checked)}/>
                                    <FormLabel htmlFor='stats-only' ml='3' mb='0'>
                                        Only Display Statistics?
                                    </FormLabel>
                                </FormControl>
                                */}
                            </>)}
                        </AccordionDetails>
                    </Accordion>

                    {false && this.state.selectedObjects.length > 0 && <>
                        <Accordion defaultExpanded>
                        <AccordionSummary>Filter Results</AccordionSummary>
                        <AccordionDetails>
                            {/* <em style={{fontStyle: 'italic'}}>Select your type of search to proceed.</em> */}

                            <MaestroMultiSearch
                                searchTerms={this.state.searchTerms}
                                onChange={(searchTerms) => this.setState({searchTerms})}
                            />
                        </AccordionDetails>
                    </Accordion>
                    </>}
                    </AccordionGroup>

                    <Box m={1.5}>

                    <Button
                        color="primary"
                        size='sm'
                        sx={{
                            // mt: 2,
                            width: '100%',
                        }}
                        onClick={this.runSearch}
                        loading={this.state.loading}
                    >
                        Run Report
                    </Button>
                    </Box>
                </Box>
            </Box>
            <Box sx={{
                marginLeft: 'var(--mm-settings-sidebar-width)',
                minHeight: 'calc(100vh - var(--Header-height) - 100px)',
                flex: '1'
            }}>

                    {this.state.loading === true && <Box sx={{p: 2, display: 'block'}}><MaestroLoader centered/></Box>}

                    {this.state.loading === false && this.state.result !== null && (
                        <this.MemoReportResults
                            // selectedCommunities={this.state.selectedCommunities}
                            // allAggregates={this.state.allAggregates}
                            reportInfo={this.state.reportInfo}
                            changeReportInfo={this.changeReportInfo}
                            // searchTerms={this.state.searchTerms}
                            result={this.state.result}
                        />
                    )}
                    {/*
                    {this.state.loading === false && this.state.result !== null && (
                        <ReportResults
                            communities={this.state.selectedCommunities}
                            aggregates={this.state.allAggregates}
                            reportInfo={{...this.state.reportInfo, statsOnly: this.state.aggregateStatsOnly}}
                            changeReportInfo={this.changeReportInfo}
                            result={this.state.result}
                        />
                    )}
                    */}

                    {this.state.loading === false && this.state.result === null && (
                        <Box sx={{
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}>
                            <SearchRoundedIcon sx={{'--Icon-fontSize': '6rem'}}/>
                            <Typography textAlign={'center'} pt={1}>
                                Use the boxes on the left to select your search terms.
                                <br/>
                                Your search results will display here.
                            </Typography>
                        </Box>
                    )}
                    </Box>
        </Box>
        )
    }
}

const NewReport = (props) => {
    useDocumentTitle(`New Report | Maestro Community Manager`);

    const location = useLocation();
    const { user } = useAuth();

    if(!user) {
        return null;
    }
    return <UnhookedNewReport location={location} user={user} {...props} />
};

export default NewReport;
